import { useEffect } from "react";

import { Form, useFormikContext } from "formik";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import Loader from "@/components/Loader";

import { LandingPageEditorFormFields } from "./LandingPageEditorFormFields";
import { LandingPageModalActions } from "./LandingPageModalActions";
import type { FormValues } from "./types";

export interface LandingPageEditorModalProps {
  isOpen: boolean;
  onClose?: () => void;
  // campaignId: string;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (value: boolean) => void;
  isLoading?: boolean;
}

export const LandingPageEditorModal = ({
  isOpen,
  onClose,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  isLoading = false,
}: LandingPageEditorModalProps) => {
  const { dirty } = useFormikContext<FormValues>();

  // TODO #campaignLanding: this is a hack to get the dirty state to work. Needs to be refactored to have modal blocker work with useConfirmLoseUnsaved
  useEffect(() => {
    setHasUnsavedChanges(dirty);
  }, [dirty, setHasUnsavedChanges]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose} className="bg-body-secondary">
        Campaign Landing Page Editor
      </ModalHeader>
      <Form>
        <ModalBody>
          {isLoading && <Loader />}
          <LandingPageEditorFormFields
            hasUnsavedChanges={hasUnsavedChanges}
            isOpen={isOpen}
          />
        </ModalBody>
        <ModalFooter>
          <LandingPageModalActions onClose={onClose} />
        </ModalFooter>
      </Form>
    </Modal>
  );
};
